import gql from 'graphql-tag';

export default gql`
query getAdminAccountDetails($gid: Int!, $thirtyDaysAgo: timestamptz!) {
  groups_by_pk(group_id: $gid) {
    group_id
    name
    slug
    domain
    parent_group_id
    settings
    created_at
    pirsch_code
    plan_id
    limits_override
    plan {
      plan_id
      name
      features
    }
    groups_privileges {
      privilege_id
      value
      privilege {
        handle
      }
    }
  }
  privileges(where: {scope: {_eq: "groups"}}) {
    handle
    privilege_id
  }
  pagesTotal: pages_aggregate(where: {group_id: {_eq: $gid}}) {
    aggregate {
      count
      max {
        updated_at
        published_at
      }
    }
  }
  pagesPublished: pages_aggregate(
    where: {group_id: {_eq: $gid}, published: {_eq: true}}
  ) {
    aggregate { count }
  }
  pagesPublishedLast30: pages_aggregate(
    where: {
      group_id: {_eq: $gid},
      published: {_eq: true},
      published_at: {_gte: $thirtyDaysAgo}
    }
  ) {
    aggregate { count }
  }
  projectsTotal: projects_aggregate(where: {group_id: {_eq: $gid}}) {
    aggregate { count }
  }
  projectsPublished: projects_aggregate(
    where: {group_id: {_eq: $gid}, published: {_eq: true}}
  ) {
    aggregate { count }
  }
  foldersTotal: folders_aggregate(
    where: {group_id: {_eq: $gid}, root: {_eq: false}}
  ) {
    aggregate { count }
  }
  foldersPublished: folders_aggregate(
    where: {group_id: {_eq: $gid}, root: {_eq: false}}
  ) {
    aggregate { count }
  }
  imagesTotal: images_aggregate(where: {group_id: {_eq: $gid}}) {
    aggregate { count }
  }
  recentlyPublishedProjects: projects(
    where: {group_id: {_eq: $gid}, published: {_eq: true}}
    order_by: {published_at: desc_nulls_last}
    limit: 10
  ) {
    project_id
    name
    slug
    published_at
    updated_at
  }
  users_roles_groups(where: {group_id: {_eq: $gid}}) {
    user {
      user_id
      full_name
      email
      active
      deactivated
      email_confirmed
      profile_pictures
      last_login
      login_count
      created_at
    }
    role {
      role_id
      handle
      name
    }
  }
  teams_items(
    where: {
      _or: [
        {folder: {group_id: {_eq: $gid}}},
        {project: {group_id: {_eq: $gid}}},
        {page: {group_id: {_eq: $gid}}}
      ]
    }
  ) {
    team_id
    team {
      name
      users_roles_teams {
        user {
          user_id
          full_name
          email
          active
          deactivated
          email_confirmed
          profile_pictures
          last_login
          login_count
          created_at
        }
        role {
          role_id
          handle
          name
        }
      }
    }
  }
}
`;
